$(document).ready(function () {
    // the user was sitting on the homepage for too long so we redirect to the application they came from
    // we drop the path or query string since we cannot get those details at this point
    window.setTimeout(function () {
        const queryString = decodeURIComponent(window.location.search);
        const searchParams = new URLSearchParams(queryString);

        if (searchParams.has("redirect_uri")) {
            const redirectUri = searchParams.get("redirect_uri");
            window.location.href = new URL(redirectUri).origin;
        }
    }, 5 * 60000);

    $("#password-show-hide-icon").on("click", function () {
        let passwordField = document.getElementById("Password");
        if (passwordField.type === "password") {
            passwordField.type = "text";
        }
        else {
            passwordField.type = "password";
        }
    });
});
